module.exports = "<gw-dynamic-component prefix=\"gwContactDetails\" variant=\"$ctrl.subtype\" props=\"$ctrl.args\"></gw-dynamic-component>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/ContactDetails/ContactDetails.html
// module id = 689
// module chunks = 0